<!-- 权益活动H5-已领取奖品详情 -->
<template>
  <van-popup
    :value="visible"
    round
    position="bottom"
    closeable
    close-icon-position="top-right"
    get-container="body"
    @input="close"
  >
    <div class="right-activity-detail">
      <div class="detail-title">权益详情</div>
      <img class="main-img" v-if="mainUrl" :src="mainUrl" />
      <div class="detail-name">{{ prize.goodsName || '权益奖品' }}</div>
      <div class="detail-base">
        <div class="base-row"><span>数量</span><em>x{{ prize.num || 1 }}</em></div>
        <div class="base-row" v-if="prize.receiveTime"><span>领取时间</span><em>{{ prize.receiveTime }}</em></div>
        <div class="base-row" v-if="prize.orderNo"><span>订单号</span><em>{{ prize.orderNo }}</em></div>
      </div>

      <div class="card-list" v-if="cardList.length">
        <div class="card-item" v-for="(card, index) in cardList" :key="card.subOrderNo || index">
          <div class="card-head">
            <span class="card-name">{{ card.goodsName || prize.goodsName }}</span>
            <span class="card-index" v-if="cardList.length > 1">{{ index + 1 }}/{{ cardList.length }}</span>
          </div>
          <div class="card-row" v-for="field in cardFields(card)" :key="field.label">
            <span class="label">{{ field.label }}</span>
            <a
              v-if="isHttpLink(field.value)"
              class="value value-link"
              :href="field.value"
              target="_blank"
              rel="noopener noreferrer"
            >{{ field.value }}</a>
            <span v-else class="value">{{ field.value }}</span>
            <div class="row-actions" v-if="field.copy || isHttpLink(field.value)">
              <span class="copy" v-if="field.copy" @click="copy(field.value)">复制</span>
              <span
                class="open-link"
                v-if="isHttpLink(field.value)"
                @click="openLink(field.value)"
              >打开链接</span>
            </div>
          </div>
        </div>
      </div>
      <div class="no-card" v-else>暂无卡券信息，请稍后刷新查看</div>

      <div class="detail-text" v-if="prize.gcText">
        <div class="text-title">使用说明</div>
        <div class="text-content" v-html="prize.gcText"></div>
      </div>
    </div>
  </van-popup>
</template>
<script>
export default {
  name: 'RightActivityPrizeDetail',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    prize: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    mainUrl() {
      const url = this.prize.gcMainUrl || this.prize.gcCoverUrl || ''
      return url.replace(/^http:/, '')
    },
    cardList() {
      return this.prize.cardList || []
    },
  },
  methods: {
    // 只展示有值的卡券字段
    cardFields(card) {
      return [
        { label: '短链', value: card.shortUrl, copy: true },
        { label: '卡号', value: card.cardNo, copy: true },
        { label: '卡密', value: card.cardPwd, copy: true },
        { label: '兑换码', value: card.redeemCode, copy: true },
        { label: '验证码', value: card.verifyCode, copy: true },
        { label: '有效期至', value: card.expireTime, copy: false },
      ].filter(item => item.value)
    },
    isHttpLink(value) {
      return typeof value === 'string' && /^https?:\/\//i.test(value)
    },
    copy(text) {
      this.$copyText(text).then(() => {
        this.$toast.success('已复制')
      }).catch(() => {
        this.$toast.fail('复制失败，请手动选择复制')
      })
    },
    openLink(url) {
      if (!this.isHttpLink(url)) return
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="less">
/* bank rootValue=37.5，本项目=75，样式 px 按 2 倍书写以对齐视觉尺寸 */
.right-activity-detail {
  box-sizing: border-box;
  max-height: 85vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 40px 32px calc(env(safe-area-inset-bottom) + 40px);

  .detail-title {
    margin-bottom: 32px;
    font-size: 34px;
    font-weight: 600;
    color: #1f2d4d;
    text-align: center;
  }
  .main-img {
    display: block;
    width: 100%;
    border-radius: 24px;
  }
  .detail-name {
    margin-top: 24px;
    font-size: 32px;
    font-weight: 500;
    color: #1f2d4d;
    line-height: 1.5;
  }
  .detail-base {
    margin-top: 20px;
    .base-row {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      font-size: 26px;
      span {
        color: #8a93a6;
      }
      em {
        font-style: normal;
        color: #5b6478;
        word-break: break-all;
      }
    }
  }
  .card-item {
    margin-top: 28px;
    padding: 28px;
    border-radius: 24px;
    background: #f7f8fc;
    .card-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 20px;
      border-bottom: 1px dashed #dfe2ea;
    }
    .card-name {
      font-size: 28px;
      font-weight: 500;
      color: #1f2d4d;
    }
    .card-index {
      font-size: 24px;
      color: #a5abb9;
    }
    .card-row {
      display: flex;
      align-items: center;
      margin-top: 20px;
      font-size: 26px;
      .label {
        flex: none;
        width: 120px;
        color: #8a93a6;
      }
      .value {
        flex: 1;
        color: #1f2d4d;
        word-break: break-all;
      }
      .value-link {
        color: #1989fa;
        text-decoration: underline;
      }
      .row-actions {
        flex: none;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        width: 144px;
        margin-left: 16px;
        gap: 12px;
      }
      .copy,
      .open-link {
        box-sizing: border-box;
        width: 100%;
        padding: 4px 0;
        border: 1px solid #e04242;
        border-radius: 22px;
        font-size: 24px;
        color: #e04242;
        text-align: center;
        white-space: nowrap;
      }
    }
  }
  .no-card {
    margin-top: 32px;
    padding: 40px 0;
    border-radius: 24px;
    background: #f7f8fc;
    font-size: 26px;
    color: #a5abb9;
    text-align: center;
  }
  .detail-text {
    margin-top: 36px;
    .text-title {
      font-size: 28px;
      font-weight: 500;
      color: #1f2d4d;
    }
    .text-content {
      margin-top: 16px;
      font-size: 26px;
      color: #8a93a6;
      line-height: 1.7;
      word-break: break-all;
      img {
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>
